import { render } from "./ProductItem.vue?vue&type=template&id=d5a35d8c&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=js"
export * from "./ProductItem.vue?vue&type=script&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=d5a35d8c&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5a35d8c"]])

export default __exports__